import axios from "axios";
import ConstantList from "app/appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/etb/patient-medication-history";
const ETB_PATIENT_PATH = ConstantList.API_ENPOINT + "/api/etb/patient";

export const getPatientBySearchDto = (dto) => {
  let url = API_PATH + "/get-all-by-search-dto";
  return axios.post(url, dto);
};

export const saveOrUpdate = (dto, id) => {
  if (id) {
    let url = API_PATH + "/save-or-update/" + id;
    return axios.put(url, dto);
  } else {
    let url = API_PATH + "/save-or-update"
    return axios.put(url, dto);
  }
};

export const saveOrUpdateList = (dto, periodId) => {
  let url = API_PATH + "/save-or-update-list/" + periodId
  return axios.put(url, dto);
}

export const getPatientById = (id) => {
  let url = ETB_PATIENT_PATH + "/" + id;
  return axios.get(url);
};

export const checkRoleDelete = (id) => {
  let url = API_PATH + "/check-role-delete/" + id;
  return axios.get(url);
};
